import CourseSchedulingDetailListModule from './containers/courseSchedulingDetailListModule'

export {default as CourseSchedulingDetailListModuleLayout} from './components/courseSchedulingDetailListModuleLayout'

export default CourseSchedulingDetailListModule
